module.exports = __webpack_public_path__ + "media/images/icon-haccps-check-blue-56c7ad5db4deaae379bff713f6e1f279.svg";